export const SystemLids = {
    initalLog: 100000,
    pageEndLog: 100001,
    endOperationLog: 100002,
    endLog: 100003,
    operationLog: 100004,
}